const FEATURES = [
  {
    icon: "ri-hd-line",
    title: "高清画质",
    desc: "支持 1080P 及以上清晰度，画面细腻，观感舒适。",
  },
  {
    icon: "ri-flashlight-line",
    title: "极速加载",
    desc: "优化播放体验，点开即看，减少等待与卡顿。",
  },
  {
    icon: "ri-device-line",
    title: "多端适配",
    desc: "电脑、平板、手机均可流畅浏览，随时随地追剧。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容聚合",
    desc: "围绕“激情丛林”聚合同类型影视，一站找齐。",
  },
];

export default function SiteIntro() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
              <span className="text-sm font-bold text-accent-700 tracking-wide">关于激情丛林</span>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950 leading-snug mb-4">
              专注“激情丛林”影视内容的高清观看体验
            </h1>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              激情丛林是一个以“激情丛林”电视剧为核心的影视内容站，汇集同类型剧集与电影，
              提供作品剧情介绍、演职人员信息与在线观看入口，帮助影视爱好者快速找到想看的内容。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              我们持续更新最新上线的影视资源，并通过分类导航、关键词搜索与相关推荐，
              让每一次找剧都更简单、更顺畅。
            </p>
            <div className="flex flex-wrap gap-3">
              <span className="flex items-center gap-1.5 bg-primary-100 text-primary-700 text-sm font-semibold px-3.5 py-2 rounded-full">
                <i className="ri-checkbox-circle-fill" aria-hidden="true"></i>
                持续更新中
              </span>
              <span className="flex items-center gap-1.5 bg-accent-100 text-accent-700 text-sm font-semibold px-3.5 py-2 rounded-full">
                <i className="ri-emotion-happy-line" aria-hidden="true"></i>
                免费在线观看
              </span>
              <span className="flex items-center gap-1.5 bg-secondary-100 text-secondary-900 text-sm font-semibold px-3.5 py-2 rounded-full">
                <i className="ri-star-smile-line" aria-hidden="true"></i>
                精选影视推荐
              </span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {FEATURES.map((feature) => (
              <div
                key={feature.title}
                className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 transition-colors"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-700 mb-4">
                  <i className={`${feature.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <h3 className="text-base font-bold text-foreground-950 mb-1.5">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}